import { render, staticRenderFns } from "./sfjaisle.vue?vue&type=template&id=10849ab7"
import script from "./sfjaisle.vue?vue&type=script&lang=js"
export * from "./sfjaisle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports